import React from "react";
import Chip from "@mui/material/Chip";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ChipRender = ({ label = null, status = null, ...props }) => {
    let formattedLabel = "Undefined";

    if (label) {
        formattedLabel = label;

        let LabelArray = [];
        const maxLength = 40;

        if (label?.length > maxLength) {
            if (label.includes(",")) {
                LabelArray = label.split(",");
                formattedLabel = LabelArray[0];
            } else {
                LabelArray = label.split(" ");
                let newString = "";
                for (let i = 0; i < LabelArray.length; i++) {
                    if ((newString + LabelArray[i]).length <= maxLength) {
                        newString += LabelArray[i] + " ";
                    } else {
                        break;
                    }
                }
                formattedLabel = newString.trim() + " ...";
            }
        }
    }

    let output = (
        <Chip
            color="default"
            variant="filled"
            className="chip"
            label={formattedLabel}
            {...props}
        />
    );

    switch (status) {
        case "success":
            output = (
                <Chip
                    icon={
                        <CheckCircleOutlineIcon
                            fontSize="small"
                            sx={{ color: "#FFF" }}
                        />
                    }
                    color="success"
                    variant="filled"
                    className="chip"
                    label={formattedLabel}
                    sx={{ color: "#FFF" }}
                    {...props}
                />
            );
            break;

        case "warning":
            output = (
                <Chip
                    icon={
                        <ErrorOutlineIcon
                            fontSize="small"
                            sx={{ color: "#FFF" }}
                        />
                    }
                    variant="filled"
                    color="warning"
                    className="chip"
                    label={formattedLabel}
                    sx={{ color: "#FFF" }}
                    {...props}
                />
            );
            break;

        case "error":
            output = (
                <Chip
                    icon={
                        <ErrorOutlineIcon fontSize="small" color="#FFF" />
                    }
                    color="error"
                    variant="filled"
                    className="chip"
                    label={formattedLabel}
                    sx={{ color: "#FFFFFF" }}
                    {...props}
                />
            );
            break;

        case "info":
            output = (
                <Chip
                    icon={
                        <InfoOutlinedIcon
                            fontSize="small"
                            sx={{ color: "#FFF" }}
                        />
                    }
                    variant="filled"
                    color="info"
                    className="chip"
                    label={formattedLabel}
                    sx={{ color: "#FFF" }}
                    {...props}
                />
            );
            break;

        default:
            break;
    }

    return output;
};

export default React.memo(ChipRender);
